import { defineStore } from "pinia";
import * as Sentry from "@sentry/vue";
import { normalizeAccessionId } from "@/utils/accessionId.js";

export const useCommonStore = defineStore("CommonStore", {
  state: () => {
    return {
      sample_id: localStorage && localStorage.getItem("sample_id")
        ? localStorage.getItem("sample_id")
        : "",
      // VP-18267: a persisted literal "undefined" (from a link built with accession_id=undefined)
      // must not come back as a truthy accession on the next visit.
      accession_id: normalizeAccessionId(localStorage ? localStorage.getItem("accession_id") : ""),
      show_vw_loading_animation:false,
      role: sessionStorage.getItem("role") || "",
    };
  },
  actions: {
    addPatientIDToSentry(patientId){
      if (patientId) {
        Sentry.setUser({ patient_id: patientId }); // Stays across events
      }
    },
    addPatientIDToFullStory(patientId){
      if (patientId) {
        let attempts = 0;
        const MAX_ATTEMPTS = 10;

        const intervalId = setInterval(() => {
          try {
            if (window.FS) {
              window.FS('setIdentity', {
                uid: patientId.toString(),
                properties: {
                  displayName: 'patient_' + patientId.toString()
                }
              });
              clearInterval(intervalId);
            }

            if (++attempts >= MAX_ATTEMPTS) {
              console.log('addPatientIDToFullStory: Max attempts reached.');
              clearInterval(intervalId);  // Prevent infinite loop
            }
          } catch (error) {
            console.log('addPatientIDToFullStory error:', error);
            clearInterval(intervalId);
          }
        }, 500);
      }
    },
    setSampleId(val) {
      if (val) {
        localStorage.setItem("sample_id", val);
        this.sample_id = val;
      } else {
        localStorage.removeItem("sample_id");
        this.sample_id = "";
      }
    },
    setRole(val) {
      if (val) {
        sessionStorage.setItem("role", val);
        this.role = val;
      } 
    },
    setAccessionId(val) {
      // VP-18267: only a numeric accession is stored. Links built with accession_id=undefined
      // used to persist the string "undefined" here, which then hid the accession input on the
      // verification screen and sent guest login a barcode that can never match.
      const accessionId = normalizeAccessionId(val);
      if (accessionId) {
        localStorage.setItem("accession_id", accessionId);
        this.accession_id = accessionId;
      } else {
        localStorage.removeItem("accession_id");
        this.accession_id = "";
      }
    },
    setJwtToken(val) {
      console.log('setJwtToken CommonStore', val);
      if (val) {
        localStorage.setItem("pnsToken", val);
      } else {
        console.log('remove pnsToken CommonStore');
        localStorage.removeItem("pnsToken");
      }
    },
    setShowVWLoadingAnimation(val){
      this.show_vw_loading_animation=val;
    }
  },
});
